import { render, staticRenderFns } from "./ScheduleSendTab.vue?vue&type=template&id=36eabf4f&scoped=true&"
import script from "./ScheduleSendTab.vue?vue&type=script&lang=js&"
export * from "./ScheduleSendTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36eabf4f",
  null
  
)

export default component.exports